document.addEventListener('DOMContentLoaded', function () {
  const slider = document.getElementById('product-slider');
  const slides = document.getElementById('product-slides');
  if (!slider || !slides) return;

  const prevBtn = document.getElementById('slider-prev');
  const nextBtn = document.getElementById('slider-next');
  const dotsContainer = document.getElementById('slider-dots');
  const cards = slides.children;

  let currentPage = 0;
  let cardsPerPage = 1;
  let totalPages = 1;
  let startX = 0;
  let isDragging = false;

  function getCardsPerPage() {
    const width = window.innerWidth;
    if (width >= 1280) return 5;
    if (width >= 1024) return 4;
    if (width >= 768) return 3;
    if (width >= 640) return 2;
    return 1;
  }

  function generateDots() {
    dotsContainer.innerHTML = '';

    if (totalPages <= 1) {
      dotsContainer.style.display = 'none';
      return;
    }

    dotsContainer.style.display = 'flex';
    const pageOfTemplate = slider.getAttribute('data-page-of') || 'Page {{ page }} of {{ total }}';

    for (let i = 0; i < totalPages; i++) {
      const dot = document.createElement('button');
      dot.className = 'w-2 h-2 transition-colors duration-200 bg-gray-300 slider-dot';
      const ariaLabel = pageOfTemplate.replace('{{ page }}', i + 1).replace('{{ total }}', totalPages);
      dot.setAttribute('aria-label', ariaLabel);
      dot.setAttribute('role', 'tab');
      dot.setAttribute('type', 'button');
      dot.onclick = () => goToPage(i);
      dotsContainer.appendChild(dot);
    }
  }

  function updateSlider() {
    cardsPerPage = getCardsPerPage();
    totalPages = Math.ceil(cards.length / cardsPerPage);
    if (currentPage >= totalPages) currentPage = totalPages - 1;
    generateDots();
    goToPage(currentPage);

    if (totalPages <= 1) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
    } else {
      if (prevBtn) prevBtn.style.display = 'flex';
      if (nextBtn) nextBtn.style.display = 'flex';
    }
  }

  function goToPage(page) {
    if (page < 0) page = 0;
    if (page >= totalPages) page = totalPages - 1;
    currentPage = page;

    const cardWidth = cards[0].offsetWidth;
    const gap = 16;
    const offset = -(page * cardsPerPage * (cardWidth + gap));
    slides.style.transform = `translateX(${offset}px)`;

    dotsContainer.querySelectorAll('.slider-dot').forEach((dot, i) => {
      const isActive = i === currentPage;
      dot.classList.toggle('bg-[#64BDEA]', isActive);
      dot.classList.toggle('bg-gray-300', !isActive);
      dot.setAttribute('aria-selected', isActive);
    });

    if (prevBtn) {
      prevBtn.disabled = currentPage === 0;
    }
    if (nextBtn) {
      nextBtn.disabled = currentPage === totalPages - 1;
    }
  }

  if (prevBtn) prevBtn.onclick = () => goToPage(currentPage - 1);
  if (nextBtn) nextBtn.onclick = () => goToPage(currentPage + 1);

  slider.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      goToPage(currentPage - 1);
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      goToPage(currentPage + 1);
    }
  });

  slider.addEventListener(
    'touchstart',
    (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    },
    { passive: true },
  );

  slider.addEventListener(
    'touchmove',
    (e) => {
      if (!isDragging) return;
    },
    { passive: true },
  );

  slider.addEventListener('touchend', (e) => {
    if (!isDragging) return;
    isDragging = false;

    const diff = startX - e.changedTouches[0].clientX;
    const threshold = 50;

    if (Math.abs(diff) > threshold) {
      diff > 0 ? goToPage(currentPage + 1) : goToPage(currentPage - 1);
    }
  });

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateSlider, 250);
  });

  updateSlider();
});

document.addEventListener('DOMContentLoaded', () => {
  const sidebar = document.getElementById('collection-sidebar');
  const header = document.querySelector('.header-group');

  if (sidebar && header) {
    let lastScrollTop = 0;
    let isScrollingUp = false;
    const scrollThreshold = 100;

    const updateSidebarPosition = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop < lastScrollTop) {
        isScrollingUp = true;
      } else {
        isScrollingUp = false;
      }
      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;

      if (isScrollingUp || scrollTop < scrollThreshold) {
        const headerHeight = header.offsetHeight;
        const offset = 20;
        sidebar.style.top = `${headerHeight + offset}px`;
      } else {
        sidebar.style.top = '20px';
      }
    };

    updateSidebarPosition();

    let scrollTimeout;
    window.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateSidebarPosition, 10);
    });

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateSidebarPosition, 100);
    });
  }
});
